document.addEventListener('DOMContentLoaded', () => {
    const bannerButton = document.getElementById('usa-gov-banner-button');
    const dropdownContainer = document.getElementById('usa-gov-banner-content');

    bannerButton.addEventListener('click', function(event) {
        event.preventDefault(); // Prevent default behavior of the button

        // Toggle the 'open' class
        dropdownContainer.classList.toggle('open');

        // Update aria-expanded attribute based on the presence of 'open' class
        const isOpen = dropdownContainer.classList.contains('open');
        dropdownContainer.setAttribute('aria-expanded', isOpen);
    });
});
